"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const Constants_1 = require("./Constants");
const drawerSiblingCss = (overflow = 'auto') => core_1.css({
    flexGrow: 1,
    overflowY: overflow,
    [`@media ${Constants_1.BREAKPOINT}`]: {
        height: '100%',
        width: '100%',
        maxHeight: '100%',
        zIndex: 0,
    },
});
const drawerSiblingAlignerCss = (maxWidth) => core_1.css({
    margin: '0 auto',
    height: '100%',
    maxHeight: '100%',
    maxWidth,
});
const DrawerSibling = ({ children, overflow, maxWidth, }) => (core_1.jsx("div", { css: drawerSiblingCss(overflow) },
    core_1.jsx("div", { css: drawerSiblingAlignerCss(maxWidth) }, children)));
exports.default = DrawerSibling;
